var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.27 10.0708C35.7632 11.564 36.9477 13.3367 37.7558 15.2877C38.564 17.2387 38.9799 19.3297 38.9799 21.4415C38.9799 23.5532 38.564 25.6443 37.7558 27.5953C36.9477 29.5462 35.7632 31.319 34.27 32.8122M29.5334 14.8091C31.2922 16.5682 32.2802 18.9539 32.2802 21.4415C32.2802 23.929 31.2922 26.3147 29.5334 28.0738M12.1789 14.7412L20.6123 6.30792C20.7997 6.12075 21.0383 5.99331 21.2981 5.9417C21.5579 5.89009 21.8272 5.91663 22.0719 6.01795C22.3166 6.11928 22.5258 6.29086 22.6731 6.51101C22.8203 6.73116 22.899 6.99002 22.8993 7.25488V35.628C22.899 35.8929 22.8203 36.1518 22.6731 36.3719C22.5258 36.5921 22.3166 36.7636 22.0719 36.865C21.8272 36.9663 21.5579 36.9928 21.2981 36.9412C21.0383 36.8896 20.7997 36.7622 20.6123 36.575L12.1789 28.1417H8.17667C6.60436 28.1417 5.1321 27.2358 4.714 25.7224C4.33077 24.3278 4.13725 22.8878 4.13868 21.4415C4.13868 19.9585 4.33879 18.5237 4.714 17.1605C5.1321 15.6453 6.60436 14.7412 8.17667 14.7412H12.1789Z",
    stroke: "white",
    strokeWidth: 1.00056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.98b18f2f48544fb8e40f7434deeaae8e.svg";
export { ForwardRef as ReactComponent };